import React from 'react';
import { Box, Button, Card, Chip, Grid, Link, Typography } from '@mui/material';
import OpenInNew from '@mui/icons-material/OpenInNew';

const imageFallback = 'https://timable.com/assets/images/event/pin.svg';

const EVENT_DATA_SOURCE = 'Timable';

const EventSuggestionCard = ({ data, intl }) => {
  const {
    reason,
    event_title: eventTitle,
    event_description: eventDescription,
    event_url: eventUrl,
    event_date: eventDate,
    event_venue: eventVenue,
    event_image_url: eventImageUrl,
    event_price: eventPrice
  } = data;

  const onShare = async () => {
    const shareTitle = eventTitle || '活動推薦';
    const shareText = reason || eventDescription || '';
    const shareUrl = eventUrl || window.location.href;

    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl
        });
        return;
      } catch (error) {
        // Continue to clipboard fallback when native share is unavailable/rejected.
      }
    }

    if (navigator.clipboard && shareUrl) {
      await navigator.clipboard.writeText(shareUrl);
    }
  };

  return (
    <Card
      style={{
        marginBottom: 12,
        padding: 16,
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
      }}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box
            style={{
              width: '100%',
              borderRadius: 10,
              overflow: 'hidden',
              background: '#f5f5f5',
              minHeight: 140
            }}
          >
            <img
              src={eventImageUrl || imageFallback}
              alt={eventTitle || 'event'}
              style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 8 }}>
          <Typography variant="h6" style={{ fontWeight: 700, color: '#222', marginBottom: 6 }}>
            {eventTitle || '-'}
          </Typography>

          {eventDescription && (
            <Typography variant="body2" style={{ color: '#555', marginBottom: 10, lineHeight: 1.6 }}>
              {eventDescription}
            </Typography>
          )}

          <Grid container spacing={1}>
            <Grid size={12}>
              <Typography variant="body2" style={{ color: '#333' }}>
                <strong>{intl.formatMessage({ id: 'chat-gpt-options-event-recommendation-content-date' })}：</strong>
                {eventDate || '-'}
              </Typography>
            </Grid>
            <Grid size={12}>
              <Typography variant="body2" style={{ color: '#333' }}>
                <strong>
                  {intl.formatMessage({ id: 'chat-gpt-options-event-recommendation-content-location' })}：
                </strong>
                {eventVenue || '-'}
              </Typography>
            </Grid>
            <Grid size={12}>
              <Typography variant="body2" style={{ color: '#333' }}>
                <strong>{intl.formatMessage({ id: 'chat-gpt-options-event-recommendation-content-price' })}：</strong>
                {eventPrice || '-'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        {reason && (
          <Grid size={12}>
            <Box style={{ background: '#f8f9fa', borderRadius: 8, padding: 12 }}>
              <Typography variant="body2" style={{ color: '#4a4a4a', lineHeight: 1.7 }}>
                <strong>推薦原因：</strong>
                {reason}
              </Typography>
            </Box>
          </Grid>
        )}

        <Grid size={12}>
          <Box display="flex" alignItems="center" style={{ gap: 8 }}>
            {eventUrl && (
              <Button
                component={Link}
                href={eventUrl}
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
                variant="outlined"
                size="small"
                startIcon={<OpenInNew />}
                style={{ flex: 1, minHeight: 32, fontSize: '16px' }}
              >
                {intl.formatMessage({ id: 'chat-gpt-options-event-recommendation-cta-detail' })}
              </Button>
            )}

            <Button
              color="primary"
              variant="contained"
              size="small"
              onClick={onShare}
              style={{ flex: 1, minHeight: 32, fontSize: '16px' }}
            >
              {intl.formatMessage({ id: 'chat-gpt-options-event-recommendation-cta-share' })}
            </Button>
          </Box>
        </Grid>

        <Grid size={12}>
          <Typography variant="caption" style={{ color: '#999', display: 'block', textAlign: 'right' }}>
            {intl.formatMessage({ id: 'chat-gpt-options-event-recommendation-data-source' })}: {EVENT_DATA_SOURCE}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
};

const EventCards = ({ data = [], intl }) => {
  if (!data.length) {
    return null;
  }

  return (
    <Box>
      {data.map((e, index) => (
        <EventSuggestionCard key={e.external_id || `${e.event_title || 'event'}-${index}`} data={e} intl={intl} />
      ))}
    </Box>
  );
};

export default EventCards;
